// extracted by mini-css-extract-plugin
module.exports = {"nomatch":"styles_nomatch__3eF2W"};